export default __webpack_public_path__ + "static/montserrat-v15-latin-800-db9a3e0ba7eaea32e5f55328ace6cf23.woff2";